import { MOBILE_BOTTOM_NAV_HEIGHT } from "../AppHeader";

export const CAPSULE_NAV_GAP_PX = 12;
export const MUI_SM_BREAKPOINT = 600;
export const PROGRESS_CAPSULE_RESERVE_PX = { xs: 88, sm: 64 };

export const shouldHideProgressCapsule = ({
  isScrolling = false,
  scrollDirection = null,
  isInteractive = false,
  hasSelection = false,
} = {}) => {
  if (hasSelection) return true;
  if (isInteractive) return false;
  if (!isScrolling) return false;
  // Hide on downward or first/unknown-direction scroll so verses stay readable.
  return scrollDirection !== "up";
};

export const getCapsuleDockBottom = ({ isZenMode = false } = {}) => {
  if (isZenMode) {
    return { xs: 72, sm: 82 };
  }
  return {
    xs: `calc(${MOBILE_BOTTOM_NAV_HEIGHT}px + ${CAPSULE_NAV_GAP_PX}px + env(safe-area-inset-bottom, 0px))`,
    sm: 24,
  };
};

export const hasMobileBottomNav = ({
  isZenMode = false,
  viewportWidth = typeof window !== "undefined" ? window.innerWidth : 1024,
} = {}) => !isZenMode && viewportWidth < MUI_SM_BREAKPOINT;

export const getCapsuleMaxY = ({
  viewportHeight,
  capsuleHeight,
  margin = 8,
  isZenMode = false,
  viewportWidth,
} = {}) => {
  const navReserve = hasMobileBottomNav({ isZenMode, viewportWidth })
    ? MOBILE_BOTTOM_NAV_HEIGHT + CAPSULE_NAV_GAP_PX
    : 0;
  return Math.max(margin, viewportHeight - capsuleHeight - margin - navReserve);
};
